import { Component, Input, signal } from '@angular/core';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatSidenav } from '@angular/material/sidenav';
import { Router } from '@angular/router';
import { AuthService } from '../../../services/auth/auth.service';

@Component({
  selector: 'app-toolbar',
  standalone: true,
  imports: [MatToolbarModule, MatIconModule, MatButtonModule, MatMenuModule],
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss']
})
export class ToolbarComponent {
  @Input() drawerSideNav!: MatSidenav;

  userData = signal<{ name: string; role: string }>({
    name: 'Admin',
    role: 'pcadmin'
  });

  constructor(
    private authService: AuthService,
    private router: Router
  ) {
    this.loadUserData();
  }

  private loadUserData(): void {
    const webUser = localStorage.getItem('web_user');
    if (webUser) {
      try {
        const user = JSON.parse(webUser);
        this.userData.set({
          name: user?.description || 'User',
          role: user?.role_description || ''
        });
      } catch {
        this.userData.set({ name: 'User', role: '' });
      }
    }
  }

  openDrawer(): void {
    this.drawerSideNav.toggle();
  }

  onLogoClick(): void {
    this.router.navigate(['/dashboard']);
  }

  onLogout(): void {
    this.authService.logout();
    this.router.navigate(['/login']);
  }
}
